/* eslint-disable no-console */
import Typograf from 'typograf';
import draggable from 'vuedraggable';
const tp = new Typograf({ locale: ['ru', 'en-US'] });

export default {
  name: 'app',
  components: {
    draggable
  },

  data() {
    return {
      appIcon: require("../../assets/app-icon.png"),
      heading: 0,
      description: 1,
      token: 2,
      bgColor: '#ffffff',
      token_fontSize: 16,
      h1_fontSize: 64,
      p_fontSize: 24,
      items: [
        { name: 'token', tag: 'div', className: 'site-banner__el site-banner__token', text: 'New', style: 'font-size: 16px' },
        { name: 'heading', tag: 'h1', className: 'site-banner__el', text: 'Dodo Pizza', style: 'font-size: 64px'},
        { name: 'description', tag: 'p', className: 'site-banner__el', text: 'Some description', style: 'font-size: 24px' },
      ],
      messageCleaned: "Message",
      enableTypo: true,
    }
  },

  computed: {
    message: {
      set: function (message) {
        this.messageCleaned = this.enableTypo ? tp.execute(message) : message;
        // If necessary, also copy val into an external variable here
      },
      get: function () {
        return this.messageCleaned
      }
    },
    itemsNotEmpty() {
      return this.items.filter(i => i && i.text);
    },
    item() {
      return (name) => this.items.find(x => x.name === name);
    },
    tokenCompSize() {
      return 'font-size:' + this.token_fontSize + 'px'
    },
    h1CompSize() {
      return 'font-size:' + this.h1_fontSize + 'px'
    },
    pCompSize() {
      return 'font-size:' + this.p_fontSize + 'px'
    }
  },

  methods: {
    uploadFile(input) {
      if (!input.files || !input.files[0]) return;

      const reader = new FileReader();
      reader.onload = ({ target }) => this.appIcon = target.result;
      reader.readAsDataURL(input.files[0]);
    },

    updateMessage() {
      this.message = this.messageCleaned;
    },

    changeToken() {
      this.item('token').style = this.tokenCompSize
    },
    changeH1() {
      this.item('heading').style = this.h1CompSize
    },
    changeP() {
      this.item('description').style = this.pCompSize
    }
  },

  mounted() {
    document.body.className = 'banner';
  },
  
  created () {
    this.items[0].style = this.tokenCompSize;
    this.items[1].style = this.h1CompSize;
    this.items[2].style = this.pCompSize;
  }
}